import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ClientDeclaration({accept,setAccept}) {
    const navigate = useNavigate();
    

    return (
        <div className="min-h-screen py-8 px-4 font-sans antialiased">
            <div className="max-w-4xl mx-auto">
                {/* Main Card Container */}
                <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden mb-6">

                    {/* Card Header */}
                    <div className="border-b border-slate-200 p-6 text-center bg-white">
                        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900">
                            UNDERTAKING
                        </h1>
                    </div>

                    {/* Scrollable Undertaking Body */}
                    <div className="p-6 sm:p-8 max-h-[580px] overflow-y-auto space-y-6">

                        <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                            FilmWings is built to connect talent with genuine clients in a safe and professional environment. This Undertaking sets the minimum standards for any brand, agency, production house, recruiter, or studio using FilmWings.
                        </p>

                        {/* Client verification */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                Client verification (GST/PAN + business proof)
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                Clients must complete verification before the hire or contact features are unlocked. This helps protect talent and reduces scams. FilmWings may request documents such as GSTIN, PAN, certificate of incorporation/registration, website/social media proof, office address proof, or proof of an authorized signatory, and may re-verify periodically.
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                                <li>GST/PAN verification may be mandatory for client categories (brands/agencies/production houses).</li>
                                <li>False documents or mismatched details may result in rejection, suspension, or a permanent ban.</li>
                                <li>FilmWings may display a “Allow to Login” only after verification is successful.</li>
                            </ul>
                        </div>

                        {/* Social media links & external portfolios */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                Social media links & external portfolios (explicit consent)
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                By adding Instagram/YouTube/portfolio links to your profile, you are choosing to share them for professional evaluation. FilmWings will display these links to support clients' discovery and shortlisting.
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                                <li>You confirm you own/control the linked accounts, or have authorization to share them.</li>
                                <li>You consent to FilmWings displaying these links on your profile and sharing them with verified clients for evaluation.</li>
                                <li>FilmWings is not responsible for content on third-party platforms, but may restrict links that appear unsafe, misleading, or unrelated.</li>
                            </ul>
                        </div>

                        {/* No misleading communication / no fake jobs */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                No misleading communication / no fake jobs
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                All communication and job briefs must be truthful, respectful, and aligned with the actual offer. Misleading messages, fake casting calls, false pay promises, or hidden conditions are prohibited.
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                                <li>No wrong/false information in briefs (role, dates, location, pay, usage rights).</li>
                                <li>No pressuring talent to move off-platform for secrecy or manipulation.</li>
                                <li>No abusive language, spam, or repeated unsolicited outreach.</li>
                            </ul>
                        </div>

                        {/* Transparent brief requirement */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                Transparent brief requirement (mandatory fields)
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                To reduce disputes, make these mandatory fields for any job post/booking request:
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                                <li>Role + deliverables</li>
                                <li>Date/time + location + duration</li>
                                <li>Payment amount + payment timeline</li>
                                <li>Usage rights (platforms, duration, geography, exclusivity/buyout if any)</li>
                                <li>Travel/stay (if applicable)</li>
                            </ul>
                        </div>

                        {/* Posting briefs & contacting talent */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                Posting briefs & contacting talent (No misleading activity)
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                To keep the platform trustworthy, you agree that:
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500 mb-3">
                                <li>Your briefs and offers will be honest and complete.</li>
                                <li>You will not post fake gigs, deceptive compensation, or hidden terms.</li>
                                <li>You will not pressure talent into off-platform commitments without clarity.</li>
                            </ul>
                            <p className="text-slate-700 text-sm sm:text-base">
                                A clear brief must include: role, date/time, location, duration, deliverables, payment, and usage expectations.
                            </p>
                        </div>

                        {/* Professional conduct and safety */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                Professional conduct and safety
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                FilmWings enforces a strict safety standard. You agree:
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                                <li>No harassment, coercion, exploitation, or inappropriate requests.</li>
                                <li>No secret recording, especially in private spaces (vanity, changing rooms, accommodation).</li>
                                <li>Provide a safe work environment and follow legal requirements (especially for minors).</li>
                            </ul>
                        </div>

                        {/* Portfolio content is for evaluation only */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                Portfolio content is for evaluation only.
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                Talent photos/videos shown on FilmWings are more for shortlisting. purposes only. You agree that:
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                                <li>You will not publish, repost, or use portfolio content publicly (social media, ads, posters, casting announcements, websites) without the talent’s separate written permission.</li>
                                <li>If you want usage rights, you will agree in writing on the platforms, use, duration, geography, exclusivity/buyout (if any), and any other terms before proceeding.</li>
                            </ul>
                        </div>

                        {/* Payment and cancellations */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                Payment and cancellations
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                Clients must maintain payment discipline and transparency.
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                                <li>Pay as per agreed terms and timelines.</li>
                                <li>Follow cancellation/reschedule rules shown in the booking flow.</li>
                                <li>No unfair deductions unless agreed upfront in writing.</li>
                            </ul>
                        </div>

                        {/* Enforcement */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                Enforcement
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base mb-3">
                                FilmWings may suspend or restrict client access if:
                            </p>
                            <ul className="text-slate-700 text-sm sm:text-base space-y-2 pl-6 list-disc marker:text-slate-500">
                                <li>Misleading briefs, fake jobs, or scam patterns are detected,</li>
                                <li>Misuse of the talent portfolio is reported.</li>
                                <li>Harassment/non-payment complaints occur repeatedly.</li>
                            </ul>
                        </div>

                        {/* DISCLAIMER */}
                        <div>
                            <h2 className="font-bold text-slate-900 text-base sm:text-lg mb-3">
                                DISCLAIMER
                            </h2>
                            <p className="text-slate-700 text-sm sm:text-base leading-relaxed">
                                We request all users to always check credentials of the requites/artists and verify the same independently before deciding to work with them. You should never transfer any money to anyone claiming to be representing FilmWIngs and demanding money for Artist Card, Audition Fee, Travel etc.
                            </p>
                        </div>

                        <div className="p-6 bg-white border-t border-slate-200">
                            {/* Checkbox Area */}
                            <div className="p-4 bg-slate-50 rounded-xl border border-slate-200 mb-6">
                                <label className="flex items-center gap-3 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={accept}
                                        onChange={(e) => setAccept(e.target.checked)}
                                        className="w-5 h-5 text-blue-600 rounded border-slate-300 focus:ring-blue-500 accent-blue-600 cursor-pointer flex-shrink-0"
                                    />
                                    <span className="text-slate-800 text-xs sm:text-sm font-semibold select-none">
                                        I agree to the Client Undertaking,{" "}
                                        <a
                                            href="https://filmwings.com/index.php/terms_service"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            className="text-blue-600 hover:text-blue-700 underline hover:no-underline"
                                        >
                                            Terms
                                        </a>{" "}
                                        and{" "}
                                        <a
                                            href="https://filmwings.com/index.php/privacy_policy"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            className="text-blue-600 hover:text-blue-700 underline hover:no-underline"
                                        >
                                            Privacy Policy
                                        </a>
                                        , and will not misuse talent portfolio content.
                                    </span>
                                </label>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}